import { render } from "./InertiaButtonSave.vue?vue&type=template&id=5668a446"
import script from "./InertiaButtonSave.vue?vue&type=script&lang=js"
export * from "./InertiaButtonSave.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__